export const CAMPANHA_ENDPOINTS = {
  VERIFICAR_PENDENCIA: cdCooperado => `/api/verificar-pendencia/${cdCooperado}`
};
